/* @ngInject */
function AuditFormFieldController ($scope, $timeout, $translate, $q, CONSTANTS, Utils, NewAssetService, AuditService, AssetService, UploadService, ToastService, BackendErrorParserService, AssetPreviewService, UdsModalService) {
  const getAttachInsideTheModuleModalController = () => $q.when(import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller'))

  $scope.flags = {
    replied: false,
    showContent: true
  }
  $scope.location = 'checklist'
  $scope.loadingAttachButton = false

  const api = {
    _getPreviewAssets,
    _removeObjectsByAssetId
  }

  activate()

  function activate () {
    if (!$scope.field.fieldValueAssets) {
      $scope.field.files = []
      $scope.field.fieldValueAssets = []
    }

    $scope.field.files = $scope.field.fieldValueAssets.filter(oFile => oFile).map(oFile => {
      return angular.extend(oFile, {
        src: {
          original: Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [oFile.id]),
          default: AssetService.getAssetThumbnailByType(oFile.type),
          thumbnail: Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_THUMBNAIL_ID, [oFile.id])
        },
        contentType: oFile.contentType,
        type: oFile.type,
        extension: oFile.extension
      })
    })

    $scope.field.fieldValueAssets = $scope.field.fieldValueAssets.filter(asset => asset).map(asset => asset.id)
    if ($scope.field.comment) {
      $scope.showObservations = true
    }
  }

  $scope.toggleContent = function () {
    $scope.flags.showContent = !$scope.flags.showContent
  }

  $scope.accordingField = function () {
    $scope.field.hasNonconformity = false
  }

  $scope.nonconformField = function () {
    $scope.field.hasNonconformity = true
  }

  $scope.discardNonconformity = function () {
    $scope.field.hasNonconformity = undefined
    $scope.flags.replied = false

    if ($scope.field.nonconformity) {
      $scope.field.nonconformity.comment = undefined
    }
  }

  $scope.saveNonconformity = function () {
    $scope.flags.replied = true
  }

  $scope.onChangeNonconformityText = function (event) {
    $scope.flags.replied = event === undefined
  }

  $scope.updateNonconformField = function () {
    $scope.disabled = false
    $scope.field.value = undefined
    $scope.field.files = $scope.field.files.filter(file => !$scope.field.fieldValueAssets.includes(file.id))
    $scope.field.fieldValueAssets = []
  }

  $scope.attach = function (aFiles, field) {
    field.loadingAttachment = true

    $scope.loadingAttachButton = true

    UploadService.uploadMultipleFileToS3(aFiles).then((uploadedFiles) => {
      const assets = uploadedFiles
      $scope.loadingAttachButton = false
      $timeout(() => {
        assets.forEach((asset) => {
          const uploadedFile = asset.files[0]
          const attachment = {
            ...uploadedFile,
            ...asset,
            generatingThumb: true
          }

          $scope.uploadedFiles.push(attachment)
          $scope.field.fieldValueAssets.push(attachment)
          field.files.push(attachment)
        })
      })
    }).catch(error => {
      $scope.loadingAttachButton = false
      if (BackendErrorParserService.isInvalidFileError(error)) {
        ToastService.showErrorToast($translate.instant('fileExtensionNotAllowed'))
      }
    }).finally(() => {
      $timeout(() => {
        field.loadingAttachment = false
      })
    })
  }

  $scope.disattach = function (oRemoveAttachment) {
    $scope.field.fieldValueAssets = $scope.field.fieldValueAssets.filter((file) => file.id !== oRemoveAttachment)
    $scope.field.files = $scope.field.files.filter((file) => file.id !== oRemoveAttachment)
  }

  $scope.onChangeComment = function (newValue) {
    $scope.field.comment = newValue
  }

  $scope.downloadAttachment = function (attachment) {
    AuditService.downloadAttachment(attachment.id)
  }

  $scope.openPreview = (index) => {
    const asset = $scope.field.files[index]
    AssetPreviewService.openAssetPreview({
      asset,
      getPreviewAssets: api._getPreviewAssets,
      location: $scope.location,
      onDeleteAsset: (assetId) => {
        $timeout(() => {
          const newAssets = api._removeObjectsByAssetId($scope.field.files, assetId)
          $scope.field.files = newAssets
        })
      }
    })
  }

  $scope.openAttachAssetsDialog = function () {
    getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
      const attachInsideTheModuleModal = UdsModalService.createModal({
        controller: AttachInsideTheModuleModalController,
        modalName: 'attachInsideTheModuleModal',
        data: {
          selectedTab: 'recents'
        },
        onClose: (assetsToAttach) => {
          if (!assetsToAttach?.length) {
            return
          }

          for (const asset of assetsToAttach) {
            NewAssetService.getAssetDetails(asset.id).then((assetDetail) => {
              $scope.uploadedFiles.push(assetDetail)
              $scope.field.fieldValueAssets.push(assetDetail)
              $scope.field.files.push(assetDetail)
            })
          }
        }
      })

      attachInsideTheModuleModal.open()
    })
  }

  function _removeObjectsByAssetId (array, assetIdToRemove) {
    return array.filter(item => item.assetId !== assetIdToRemove)
  }

  function _getPreviewAssets () {
    const deferred = $q.defer()
    $timeout(() => {
      deferred.resolve({
        assets: $scope.field.files,
        count: $scope.field.files.length
      })
    }, 100, true)
    return deferred.promise
  }

  $scope.isAndroidApp = function () {
    if (Utils.isInCordovaWebView() || Utils.isInReactNativeWebView()) {
      var ua = navigator.userAgent.toLowerCase()
      var isAndroid = ua.indexOf('android') > -1
      if (isAndroid) {
        return true
      }
    }
    return false
  }

  $scope.attActions = {
    download: $scope.downloadAttachment,
    delete: $scope.disattach.bind($scope)
  }
}

export { AuditFormFieldController }
